'use strict';

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

module.exports = invariant;



/*****************
 ** WEBPACK FOOTER
 ** ./~/tiny-invariant/dist/tiny-invariant.cjs.js
 ** module id = 606
 ** module chunks = 0
 **/